import React, { memo } from 'react'
import { INavRoute } from 'types/routes'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useUserDetails } from 'utils/hooks'
import IssuesContainer from './IssuesContainer'
import { NavLink } from './NavLink'
import NotificationsContainer from './NotificationsContainer'

interface IMenuProps {
  routes: INavRoute[]
}

const Menu = memo<IMenuProps>(({ routes }) => {
  const { getFlag } = useFeatureFlagContext()
  const { userDetails } = useUserDetails()
  const { userType = '' } = userDetails || {}
  const { enabled: mpNotificationsCenter } = getFlag('mpNotificationsCenter')

  return (
    <ul className='nav-right fr dn db-l'>
      {routes
        .filter(route => !!route.display)
        .map(route => (
          <NavLink route={route} key={route.name} />
        ))}
      {['employee', 'admin'].includes(userType) && (
        <li className='fl'>
          <IssuesContainer />
        </li>
      )}
      {mpNotificationsCenter && ['employee', 'admin'].includes(userType) && (
        <li className='fl'>
          <NotificationsContainer />
        </li>
      )}
    </ul>
  )
})

export default Menu
